import { render, staticRenderFns } from "./AchievementBadge.vue?vue&type=template&id=22dcce68&scoped=true"
import script from "./AchievementBadge.vue?vue&type=script&lang=js"
export * from "./AchievementBadge.vue?vue&type=script&lang=js"
import style0 from "./AchievementBadge.vue?vue&type=style&index=0&id=22dcce68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dcce68",
  null
  
)

export default component.exports